export default "__VITE_ASSET__CcvYWBwn__"